import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { API } from 'aws-amplify';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CONST_AWS_API } from 'src/app/core/constants';
import { environment } from 'src/environments/environment';
import { CommanSubscribeService } from './../../../../../../core/services/comman-subscribe.service';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { SvgService } from 'src/app/core/services/svg.service';
declare let $: any;
declare var WTSDK: any;

@Component({
  selector: 'app-expo-studio',
  templateUrl: './expo-studio.component.html',
  styleUrls: ['./expo-studio.component.scss']
})
export class ExpoStudioComponent implements OnInit {
  isStarted = true;
  AuthToken: any;
  uname: any;
  pword: any;
  Data: any;
  orgID: any;
  session_uid: any;

  qualityConstants = {
    bad: 'bad',
    good: 'good',
    excellent: 'excellent',
  };

  MediaTypes = {
    AUDIO: 'AUDIO',
    VIDEO: 'VIDEO'
  };

  MediaStates = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED'
  };
  token: any;
  userName: any;
  waiting: number;
  preview: number;
  live: number;
  userInfo: any;
  expoInfo: any;
  rooms: any;
  expo_id: any;
  session_id: any;
  expoInterval: ReturnType<typeof setInterval> | undefined; //NodeJS.Timer;;
  userInfoSubscription: any;
  ip: any = null;
  streamAdsData: any;
  sponsorData: any;
  preloadAdsdata: any[];
  adVideo: any;
  allAds: any;
  eventHomeAdsTop: any[];
  eventHomeAdsRight: any[];
  streamAdsDataRight: any[];
  streamAdsDataTop: any[];
  streamAds: any;
  streamInfoData: any;
  streamInfo: any = {};
  adInfo: any;
  slugInfoSubscr: Subscription;
  assets_url: any;
  video_icon: string = 'video-hover';
  audio_icon: string = 'mic-hover';
  constructor(private route: ActivatedRoute,
    private router: Router,
    private ngxLoader: NgxUiLoaderService,
    public toastr: ToastrService,
    private commanSubscribeService: CommanSubscribeService,
    private location: Location,
    private sanitizer: DomSanitizer,
    private svgService: SvgService
  ) {
    this.token = this.route.snapshot.params.room_token;
    this.expo_id = this.route.snapshot.params.expo_id;
    this.session_id = this.route.snapshot.params.session_id;
    console.log(this.token);
    this.videoRoom = this.token;

    // let expo_id = this.route.snapshot.params.expo_id;

  }

  ngOnInit() {
    this.assets_url = environment.assets_url;
    this.commanSubscribeService.sendScreenStatus(false);
    this.userInfo = this.commanSubscribeService.userInfo;
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.slugInfoSubscr = this.commanSubscribeService.getSlugData().subscribe(response => {
      this.adInfo = response;
      this.eventDetails(this.adInfo);
    });
    this.getUserInfo();
    this.getLiveEventById();
    console.log("this.userInfo", this.userInfo);
    this.getExpoDetails();
    this.expoInterval = setInterval(() => {
      this.getExpoDetails();
    }, 4 * 5000);
  }
  getUserInfo() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let splits = this.route.snapshot.params.ticket_key.split("-");
    let url = CONST_AWS_API.GET_CONTACT_DETAILS + '/' + splits[1];
    API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        let userInfo = response['data']['Data'];
        userInfo.signedIn = true;
        userInfo.is_profile_completed = true;
        userInfo.access_token = this.userInfo.access_token;
        this.commanSubscribeService.sendUserInfo(userInfo);
        this.guestConnect();
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }
  getExpoDetails() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_EXPO_BY_ID + '/' + this.expo_id;
    API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        // console.log("response", response);
        this.expoInfo = response.data.Data;
        this.rooms = response.data.Data.rooms.filter(e => e.skreens_access_key == this.token)[0];
        if (this.rooms.room_status != 1) {
          this.toastr.success("Video session is closed");
          this.disconnect();
        }
        console.log("all", this.expoInfo, "rooms", this.rooms);
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });

  }
  /// video room /// 

  videoRoom;
  videoUserName;
  host = true;
  myID;
  myRoom = 0;
  roomSelect = 0;
  roomName = "Waiting";
  myStream;
  vrUID;
  gotStreamInterval;
  waitingParticipant = [];
  previewParticipant = [];
  liveParticipant = [];
  startVideoRoom = false;
  copyGuestUrl = false;
  screenShare: any = {
    isSharedScreen: false,
    streamId: ""
  };

  getRoom() {
    $.ajax({
      url: environment.skreens.api_prefix + '/room/' + this.vrUID,
      type: "GET",
      beforeSend: (request) => {
        request.setRequestHeader('x-skr-di-auth-token', this.AuthToken);
      },
      dataType: 'json',
      contentType: "application/json",
      success: (data) => {
        console.log("Video Room access_key " + data.access_key, "data", data);
        this.videoRoom = data.access_key;
        console.log("videoRoom: " + this.videoRoom);
        this.videoUserName = this.uname;
        document.getElementById("videoRoomDiv").style.display = "block";
        this.startVideoRoom = true;
      }
    })
  }

  getRoomInfo() {
    var roomData;
    return new Promise((resolve, reject) => {
      $.ajax({
        url: environment.skreens.api_prefix + '/room-connect/' + this.videoRoom,
        type: "POST",
        dataType: 'json',
        contentType: "application/json",
        success: (data) => {
          console.log("getRoomInfo", JSON.stringify(data));
          roomData = data.room_data;
          resolve(roomData);
        }
      });
    })
  }
  async goConnect() {
    await this.getRoomInfo()
      .then((data: any) => {
        console.log("roomData: " + JSON.stringify(data))
        WTSDK.Session.connect(data.token, this.videoUserName);
      })
      .catch(resp => {
        console.log("resp code ::", resp.code)
        console.error(resp);
      })
  }
  roomConnect() {
    this.addListenersEvents();
    //console.log("videoRoom: " + videoRoom);
    console.log("VideoRoom Guest URL: https://media-server.skreens.tv/demos/sampleVideoRoom/guest.html?token=" + this.videoRoom)
    //  document.getElementById("guestURL").innerText = "VideoRoom Guest Input URL: https://media-server.skreens.tv/demos/studioSampleCode/guest.html?token=" + videoRoom;

    // let checkboxVR = document.getElementById("checkbox-VR");
    let vw = document.getElementById("videoWrapper");
    // vw.style.display = "flex";
    this.goConnect();
    // var svr = document.getElementById("startVideoRoom")
    // svr.innerText = "no_meeting_room";
    // svr.onmouseout = function(){vrStopFunc()};
    // svr.onclick = function() {disconnect()};
    // var svrSpan = document.createElement("SPAN");
    // svrSpan.className = "tooltiptext"
    // svrSpan.id = "VRTooltip"
    // svrSpan.innerText = "Stop WebRTC VideoRoom";
    // svr.appendChild(svrSpan);
    this.copyGuestUrl = true;
    // document.getElementById("copyGuestURL").disabled = false;
  }
  // video room end /// 

  // event listeners
  participants: any = [];
  addListenersEvents() {
    WTSDK.SessionListeners.onMosReport(({ participantId, stats }) => {
      if (participantId == this.myID) {
        // console.log("stats: " + JSON.stringify(stats))
        // document.getElementById(`${participantId}-network-video`).innerText = "Network Video: " + stats.video ? "Network Video: " + stats.video : 'N/A';
        // document.getElementById(`${participantId}-network-audio`).innerText = "Network Audio: " + stats.audio ? "Network Audio: " + stats.audio : 'N/A';
        // document.getElementById(`${participantId}-network-rtt`).innerText = "Network RTT: " + stats.RTT ? "Network RTT: " + stats.RTT : 'N/A';
        if (stats.videoStat) {
          //      document.getElementById("MOSFrameRateSpan").innerText = "Measured FrameRate: " + stats.videoStat.frameRate ? "Measured FrameRate: " + stats.videoStat.frameRate: "N/A";
          //      document.getElementById("MOSResolutionSpan").innerText = "Measured Resolution: " + stats.videoStat.frameWidth + " x " + stats.videoStat.frameHeight ? "Measured Resolution: " + stats.videoStat.frameWidth + " x " + stats.videoStat.frameHeight : "N/A" + " x " + "N/A"
          // document.getElementById(`${participantId}-network-frameRate`).innerText = "Network FrameRate: " + (stats.videoStat && stats.videoStat.frameRate) ? "Network FrameRate: " + stats.videoStat.frameRate : "N/A";
        }
        if (this.myRoom == 2) {  //only update resolution and frameRate from quality when in live room.
          switch (stats.video) {
            case this.qualityConstants.excellent:
              WTSDK.Participant.setMediaQuality({ videoHeight: 720, videoWidth: 1280, frameRate: 30 });
              document.getElementById(`${participantId}-connection-container`).style.backgroundColor = '#2dc937'
              break;
            case this.qualityConstants.good:
              WTSDK.Participant.setMediaQuality({ videoHeight: 480, videoWidth: 270, frameRate: 10 });
              document.getElementById(`${participantId}-connection-container`).style.backgroundColor = 'yellow'
              break;
            case this.qualityConstants.bad:
              WTSDK.Participant.setMediaQuality({ videoHeight: 144, videoWidth: 81, frameRate: 10 });
              document.getElementById(`${participantId}-connection-container`).style.backgroundColor = 'red'
              break;
            default:
          }
        }
      }
    })

    // WTSDK.ErrorListeners.onSessionError(event => {
    //   // Error handling
    //   if (event.error.code === 206) {
    //     // Handle full room error
    //   }
    // });


    WTSDK.SessionListeners.onConnected(() => {
      //message recieved
      WTSDK.SessionListeners.onMessageReceived(({ message, user }) => {
        this.messageRead(message);
      });


      //On participant connect to the Session

      // WTSDK.ParticipantListeners.onParticipantSpeaking(participantId => {
      //   //console.log(participantId + " started talking");
      //   let partContainer = document.getElementById(participantId + "-talking")
      //   partContainer.style.display = "block";
      //   // On participant speaking event
      // });

      // WTSDK.ParticipantListeners.onParticipantStopSpeaking(participantId => {
      //   //console.log(participantId['participantId'] + " stopped talking");
      //   let partContainer = document.getElementById(participantId + "-talking")
      //   partContainer.style.display = "none";
      //   // On participant stop speaking event
      // });

      WTSDK.ParticipantListeners.onParticipantLeft(participantId => {
        console.log("participant: " + participantId['participantId'] + " left");
        let el = document.getElementById(participantId['participantId'] + "-VC");
        el.remove();

        if (this.screenShare.isSharedScreen && this.screenShare.streamId == participantId['participantId']) {
          this.screenShare.isSharedScreen = false;
          this.screenShare.streamId = "";
        }

      });

      WTSDK.ParticipantListeners.onParticipantMediaStreamChanged(participant => {
        console.log("MediaStateChanged: " + JSON.stringify(participant));
        if (participant.mediaType == 'VIDEO' && participant.mediaState == 'DISABLED') {
          document.getElementById(participant.participantId + '-videoOff').style.display = 'block';
        }
        if (participant.mediaType == 'VIDEO' && participant.mediaState == 'ENABLED') {
          document.getElementById(participant.participantId + '-videoOff').style.display = 'none';
        }
        if (participant.mediaType == 'AUDIO' && participant.mediaState == 'DISABLED') {
          document.getElementById(participant.participantId + '-audioOff').style.display = 'block';
        }
        if (participant.mediaType == 'AUDIO' && participant.mediaState == 'ENABLED') {
          document.getElementById(participant.participantId + '-audioOff').style.display = 'none';
        }
      })

      WTSDK.SessionListeners.onStreamCreated(stream => {
        const { local, participantName, streams, participantId, settings } = stream;
        if (!document.getElementById(participantId + "-VC")) {
          console.log("onStreamCreated stream: " + JSON.stringify(stream));
          let partContainer = document.createElement("div");
          partContainer.id = participantId + "-VC";


          let videoContainer = document.createElement("div");
          videoContainer.className = "videoContainer stream-video video-container";
          let video = document.createElement("video");
          video.id = participantId;
          video.className = local ? "local w-100 video-fit" : "remote w-100 video-fit";
          video.autoplay = true;
          video.muted = local ? true : false;
          video.srcObject = stream.stream;
          let videoOff = document.createElement("img");
          videoOff.className = "video-off";
          videoOff.id = participantId + "-videoOff";
          // videoOff.setAttribute("src", this.assets_url + "stream-icons/video.svg");
          videoOff.setAttribute("src", this.svgService.video);
          videoOff.style.display = settings.mutedVideo ? "block" : "none";
          videoContainer.appendChild(video);
          videoContainer.appendChild(videoOff);

          let audioOff = document.createElement("img");
          audioOff.className = "audio-off";
          audioOff.id = participantId + "-audioOff";
          // audioOff.setAttribute("src", this.assets_url + "stream-icons/mic.svg");
          audioOff.setAttribute("src", this.svgService.mic);
          audioOff.style.display = settings.mutedAudio ? "block" : "none";

          let partExists = false;
          this.participants.forEach((e, i) => {
            if (this.participants[i].id == stream.participantId && this.participants[i].name == stream.participantName) {
              partExists = true;
            }
          });

          if (!partExists) {
            this.participants.push({ id: stream.participantId, name: stream.participantName, local: stream.local, uri: "https://director.skreens.tv/room/#/participant-only?access_key=" + this.videoRoom + "&participant_id=" + stream.participantId });
          }

          if (participantName && participantName.includes("Screen")) {

            partContainer.className = "participantLocal videoRoom-container-100 relative vid-block";
            this.screenShare.isSharedScreen = true;
            this.screenShare.streamId = participantId;
            partContainer.appendChild(videoContainer);
            let is = document.createElement("div");
            is.className = "user-status";
            let screenShareDiv = document.querySelector("#screen-share");
            let partNameMain = document.createElement("div");
            partNameMain.className = "partNameCls";
            let partNameDiv = document.createElement("div");
            partNameDiv.id = participantId + "-partNameDiv"
            let partName = document.createElement("span");
            partNameDiv.className = "partName";
            partName.classList.add("e1-text");
            partName.textContent = participantName;
            partNameDiv.appendChild(is);
            partNameDiv.appendChild(audioOff);
            partNameDiv.appendChild(partName);
            partNameMain.appendChild(partNameDiv);
            videoContainer.appendChild(partNameMain);
            screenShareDiv.appendChild(partContainer);

          } else if (local) {
            this.myStream = stream.stream;
            this.myID = participantId;
            partContainer.className = "participantLocal videoRoom-container-33 relative vid-block";
            console.log("local");
            let muteButton = document.createElement("img");
            muteButton.onclick = () => { this.voiceOff(participantId) };
            muteButton.id = participantId + "-muteButton";
            muteButton.className = "ml-10 pointer";
            // muteButton.setAttribute("src", this.assets_url + "stream-icons/mic-hover.svg");
            muteButton.setAttribute("src", this.svgService.mic_hover);
            muteButton.setAttribute('matTooltip', "Mute Audio");
            muteButton.setAttribute('matTooltipPosition', "above");

            let videoButton = document.createElement("img");
            videoButton.onclick = () => { this.videoOff(participantId) };
            videoButton.id = participantId + "-videoButton";
            // videoButton.setAttribute("src", this.assets_url + "stream-icons/video-hover.svg");
            videoButton.setAttribute("src", this.svgService.video_hover);
            videoButton.setAttribute('matTooltip', "Pause Video");
            videoButton.setAttribute('matTooltipPosition', "above");

            let locWrapper = document.createElement("div");
            locWrapper.id = participantId + "-locDiv";
            locWrapper.className = "locDiv"
            // let loc = document.createElement("p");
            // loc.id = participantId + "-loc";
            // loc.className = "localText";
            // loc.innerHTML = "local";
            // locWrapper.appendChild(loc);
            // partContainer.appendChild(locWrapper);

            // let stats = document.createElement("div");
            // stats.id = participantId + "-stats";
            // stats.className = "stats";
            // let cc = document.createElement("div");
            // cc.id = participantId + "-connection-container"
            // cc.className = "connection"
            // let nv = document.createElement("p");
            // nv.id = participantId + "-network-video";
            // let na = document.createElement("p");
            // na.id = participantId + "-network-audio";
            // let nr = document.createElement("p");
            // nr.id = participantId + "-network-rtt";
            // let nf = document.createElement("p");
            // nf.id = participantId + "-network-frameRate";
            // let titleDiv = document.createElement("div");
            // let title = document.createElement("span");
            // title.innerHTML = "Participant: " + participantId;
            // titleDiv.appendChild(title);
            // title.appendChild(cc);
            // stats.appendChild(titleDiv);
            // stats.appendChild(nv);
            // stats.appendChild(na);
            // stats.appendChild(nr);
            // stats.appendChild(nf);
            // partContainer.appendChild(stats);
            // stats.style.display = "none";

            // let statsButtonDiv = document.createElement("div");
            // statsButtonDiv.id = participantId + "-statsButtonDiv";
            // statsButtonDiv.className = "statsButtonDiv";
            // let statsButton = document.createElement("button");
            // statsButton.onclick = ()=> {statsOn(participantId)};
            // statsButton.id = participantId + "-statsButton";
            // statsButton.className = "showStats";
            // statsButton.innerHTML = "query_stats";
            // statsButtonDiv.appendChild(statsButton);
            // statsButtonDiv.display = "none";
            // partContainer.appendChild(statsButtonDiv);
            // WTSDK.Session.enableStats();

            // let screenShareButtonDiv = document.createElement("div");
            // screenShareButtonDiv.id = participantId + "-screenShareButtonDiv";
            // screenShareButtonDiv.className = "screenShareButtonDiv";
            // let screenShareButton = document.createElement("button");
            // screenShareButton.onclick = function() {shareOn(participantId)};
            // screenShareButton.id = participantId + "-screenShareButton";
            // screenShareButton.className = "screenShareButton";
            // screenShareButton.innerHTML = "screen_share";
            // screenShareButtonDiv.appendChild(screenShareButton);
            // partContainer.appendChild(screenShareButtonDiv);

            let is = document.createElement("div");
            // is.id = "inputSelect";
            is.className = "user-status";
            // let dstat = document.createElement("div");
            // dstat.id = "dstat";

            // let did = document.createElement("p");
            // did.id = "deviceIDSpan";
            // dstat.appendChild(did);
            // let br = document.createElement("p");
            // br.id = "frameRateSpan";
            // dstat.appendChild(br);
            // let res = document.createElement("p");
            // res.id = "resSpan"
            // dstat.appendChild(res);
            // let room = document.createElement("p");
            // room.id = "roomSpan" + participantId
            // room.innerText = this.roomName;
            // dstat.appendChild(room);
            // is.appendChild(dstat);
            // let input = document.createElement("div");
            // input.id = "select";
            // let aiL:any = document.createElement("label");
            // aiL.for = "audioSource"
            // aiL.innerText = "Select Audio Input: "
            // input.appendChild(aiL);
            // let ai = document.createElement("select");
            // ai.id = "audioSource";
            // input.appendChild(ai);
            // let lineBreak = document.createElement("br");
            // input.appendChild(lineBreak);
            // let viL:any = document.createElement("label");
            // viL.for = "videoSource"
            // viL.innerText = "Select Video Input: "
            // input.appendChild(viL);
            // let vi = document.createElement("select");
            // vi.id = "videoSource";
            // input.appendChild(vi);
            // is.appendChild(input);
            // ai.onchange = ()=> {this.changeAudioInput()};
            // vi.onchange = ()=> {this.changeVideoInput()};
            // partContainer.appendChild(is);

            // let talkingWrapper = document.createElement("div");
            // talkingWrapper.id =  participantId + "-talkingDiv";
            // talkingWrapper.className = "talkingDivLocal"
            // let talking = document.createElement("p");
            // talking.id = participantId + "-talking";
            // talking.className = "talking";
            // talking.style.display = "none";
            // talking.innerHTML = "SPEAKING";
            // talkingWrapper.appendChild(talking);
            // partContainer.appendChild(talkingWrapper);

            partContainer.appendChild(videoContainer);

            let container = document.querySelector("#videoWrapper");
            let partNameMain = document.createElement("div");
            partNameMain.className = "partNameCls";
            let partNameDiv = document.createElement("div");
            partNameDiv.id = participantId + "-partNameDiv"
            let partName = document.createElement("span");
            partNameDiv.className = "partNameLocal";
            partName.classList.add("e1-text");
            partName.textContent = participantName;
            partNameDiv.appendChild(is);
            partNameDiv.appendChild(audioOff);
            partNameDiv.appendChild(partName);
            partNameMain.appendChild(partNameDiv);
            videoContainer.appendChild(partNameMain);
            container.appendChild(partContainer);

            let meterGraph = document.createElement("div");
            meterGraph.id = "meterGraph";
            let meter = document.createElement("div");
            meter.id = "meter"
            meterGraph.appendChild(meter);
            partContainer.appendChild(meterGraph);

            // navigator.mediaDevices.enumerateDevices().then(this.gotDevices).catch(handleError);
            // WTSDK.GetMediaDevices().then(data => console.log("GetMediaDevices: " + JSON.stringify(data)));
            // WTSDK.Participant.setMediaQuality({videoHeight: 135, videoWidth: 240, frameRate: 10});
            // console.log("myStream: " + JSON.stringify(myStream));
            // setInterval(gotStream, 1000, myStream);
            //createMeter(myStream);
            this.updateVideoHtmlIntervalCalltimer();
          } else {
            // let talkingWrapper = document.createElement("div");
            // talkingWrapper.id = participantId + "-talkingDiv";
            // talkingWrapper.className = "talkingDiv"
            // let talking = document.createElement("p");
            // talking.id = participantId + "-talking";
            // talking.className = "talking";
            // talking.style.display = "none";
            // talking.innerHTML = "SPEAKING";
            // talkingWrapper.appendChild(talking);
            // partContainer.appendChild(talkingWrapper);

            partContainer.className = "participant videoRoom-container-33 relative vid-block";
            partContainer.appendChild(videoContainer);
            let is = document.createElement("div");
            is.className = "user-status";
            let container = document.querySelector("#videoWrapper");
            let partNameMain = document.createElement("div");
            partNameMain.className = "partNameCls";
            let partNameDiv = document.createElement("div");
            partNameDiv.id = participantId + "-partNameDiv"
            let partName = document.createElement("span");
            partNameDiv.className = "partName";
            partName.textContent = participantName;
            partNameDiv.appendChild(is);
            partNameDiv.appendChild(audioOff);
            partNameDiv.appendChild(partName);
            partNameMain.appendChild(partNameDiv);
            videoContainer.appendChild(partNameMain);
            container.appendChild(partContainer);

          }
          // this.roomSelected();
        }
      });
    });
  }

  updateVideoHtmlInterval: any;
  classes = ['videoRoom-container-33', 'videoRoom-container-50', 'videoRoom-container-100'];
  updateVideoHtmlIntervalCalltimer() {
    this.updateVideoHtmlInterval = setInterval(() => {

      this.participants.forEach(e => {
        let div = document.getElementById(e.id + "-VC");
        if (div) {
          this.classes.forEach(className => {
            div.classList.remove(className);
          });
          if (this.screenShare.isSharedScreen && e.id == this.screenShare.streamId) {
            div.classList.add('videoRoom-container-100');
          } else if (this.screenShare.isSharedScreen && e.id != this.screenShare.streamId) {
            div.classList.add('videoRoom-container-50');
          } else if (!this.screenShare.isSharedScreen) {
            div.classList.add('videoRoom-container-33');
          }
        }
      });

    }, 1000);
  }

  soundStatus = true;
  vidStatus = true;
  soundOff() {
    let muteButton = document.getElementById("audioButton");
    let muteButton1 = document.getElementById("audioButton1");
    if (this.soundStatus) {
      // muteButton.setAttribute("src", this.assets_url + "stream-icons/mic.svg");
      muteButton.setAttribute("src", this.svgService.mic);
      // muteButton1.setAttribute("src", this.assets_url + "stream-icons/mic.svg");
      this.audio_icon = 'mic';
      WTSDK.Participant.disableAudio();
    } else {
      // muteButton.setAttribute("src", this.assets_url + "stream-icons/mic-hover.svg");
      muteButton.setAttribute("src", this.svgService.mic_hover);
      // muteButton1.setAttribute("src", this.assets_url + "stream-icons/mic-hover.svg");
      this.audio_icon = 'mic-hover';
      WTSDK.Participant.enableAudio();
    }
    this.soundStatus = !this.soundStatus;
  }

  vidOff() {
    let videoButton = document.getElementById("videoButton");
    let videoButton1 = document.getElementById("videoButton1");
    if (this.vidStatus) {
      // videoButton.setAttribute("src", this.assets_url + "stream-icons/video.svg");
      videoButton.setAttribute("src", this.svgService.video);
      // videoButton1.setAttribute("src", this.assets_url + "stream-icons/video.svg");
      this.video_icon = 'video';

      WTSDK.Participant.disableVideo();
    } else {
      // videoButton.setAttribute("src", this.assets_url + "stream-icons/video-hover.svg");
      videoButton.setAttribute("src", this.svgService.video_hover);
      // videoButton1.setAttribute("src", this.assets_url + "stream-icons/video-hover.svg");
      this.video_icon = 'video-hover';

      WTSDK.Participant.enableVideo();
    }
    this.vidStatus = !this.vidStatus;
  }

  // sendMessage() {
  //   let d = { waiting: this.waitingParticipant, preview: this.previewParticipant, live: this.liveParticipant }
  //   console.log("sendMessage: " + JSON.stringify(d));
  //   WTSDK.Session.sendMessage(JSON.stringify(d));
  //   this.messageRead(JSON.stringify(d));
  // }
  voiceOff(participantId) {
    let muteButton = document.getElementById(participantId + "-muteButton");
    muteButton.onclick = () => { this.voiceOn(participantId) };
    // muteButton.setAttribute("src", this.assets_url + "stream-icons/mic.svg");
    muteButton.setAttribute("src", this.svgService.mic);
    // muteButton.setAttribute('matTooltip', "Unmute Audio");
    // muteButton.setAttribute('matTooltipPosition', "above");
    // muteButton.innerHTML = "volume_off";
    WTSDK.Participant.disableAudio();
  }
  voiceOn(participantId) {
    let muteButton = document.getElementById(participantId + "-muteButton");
    muteButton.onclick = () => { this.voiceOff(participantId) };
    // muteButton.setAttribute("src", this.assets_url + "stream-icons/mic-hover.svg");
    muteButton.setAttribute("src", this.svgService.mic_hover);
    // muteButton.setAttribute('matTooltip', "Mute Audio");
    // muteButton.setAttribute('matTooltipPosition', "above");
    // muteButton.className = "mute";
    // muteButton.innerHTML = "volume_up";
    WTSDK.Participant.enableAudio();
  }

  videoOff(participantId) {
    let videoButton = document.getElementById(participantId + "-videoButton");
    videoButton.onclick = () => { this.videoOn(participantId) };
    // videoButton.setAttribute("src", this.assets_url + "stream-icons/video.svg");
    videoButton.setAttribute("src", this.svgService.video);

    // videoButton.setAttribute('matTooltip', "Play Video");
    // videoButton.setAttribute('matTooltipPosition', "above");
    // videoButton.className = "unPauseVideo";
    // videoButton.innerHTML = "videocam_off";
    WTSDK.Participant.disableVideo();
  }

  videoOn(participantId) {
    let videoButton = document.getElementById(participantId + "-videoButton");
    videoButton.onclick = () => { this.videoOff(participantId) };
    // videoButton.setAttribute("src", this.assets_url + "stream-icons/video-hover.svg");
    videoButton.setAttribute("src", this.svgService.video_hover);
    // videoButton.setAttribute('matTooltip', "Pause Video");
    // videoButton.setAttribute('matTooltipPosition', "above");
    // videoButton.className = "pauseVideo";
    // videoButton.innerHTML = "videocam";
    WTSDK.Participant.enableVideo();
  }


  setMessageTime = () => {
    const now = new Date();
    const hours = now.getHours() >= 10 ? now.getHours() : `0${now.getHours()}`;
    const minutes = now.getMinutes() >= 10 ? now.getMinutes() : `0${now.getMinutes()}`;
    return `${hours}:${minutes}`
  }

  visibleRooms: any = [];
  async messageRead(message) {
    var waiting = 0;
    var preview = 0;
    // var live = 0;
    let mr: any = [];
    mr.push(message);
    var m = JSON.parse(mr);
    console.log("m: " + JSON.stringify(m));
    // m.forEach((e) => {
    //   console.log("message this: " + JSON.stringify(e));
    // })
    console.log("waitingParticipants: " + JSON.stringify(m.waiting));
    console.log("previewParticipants: " + JSON.stringify(m.preview));
    console.log("liveParticipants: " + JSON.stringify(m.live));
    console.log("Message time: " + this.setMessageTime());

    var myRoom = 0;
    m.waiting.forEach((e) => {
      if (!e.mute && e.id == this.myID) {
        waiting = 1;
      }
      console.log("waiting: " + waiting);
    });
    m.preview.forEach((e) => {
      if (!e.mute && e.id == this.myID) {
        preview = 2;
      }
      console.log("preview: " + preview);
    });
    // m.live.forEach((e) => {
    //   if (!e.mute && e.id == e.myID) {
    //     this.live = 4;
    //   }
    //   console.log("live: " + e.live);
    // });

    let rsTotal = waiting + preview;// + this.live;
    console.log("rsTotal: " + rsTotal);
    switch (rsTotal) {
      case 1:
        myRoom = 0;
        break;
      case 2:
        myRoom = 1;
        break;
      case 3:
        myRoom = 3;
        break;
      case 4:
        myRoom = 2;
        break;
      case 5:
        myRoom = 4;
        break;
      case 6:
        myRoom = 5;
        break;
      case 7:
        myRoom = 6;
        break;
    }
    console.log("myRoom: " + myRoom);

    m.waiting = m.waiting || [];
    m.preview = m.preview || [];
    m.live = m.live || [];

    this.visibleRooms = [];
    switch (myRoom) {
      case 0:
        m.preview.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).pause();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "none";
          }
        });
        m.live.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).pause();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "none";
          }
        });
        m.waiting.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).play();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "block";
          }
          this.visibleRooms.push(e.id);
        });
        console.log("I'm in the waiting room");
        this.roomName = "Waiting";
        WTSDK.Participant.setMediaQuality({ videoHeight: 135, videoWidth: 240, frameRate: 10 })
        break;
      case 1:
        m.waiting.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).pause();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "none";
          }
        });
        m.live.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).pause();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "none";
          }
        });
        m.preview.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).play();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "block";
          }
          this.visibleRooms.push(e.id);
        });
        console.log("I'm in the preview room");
        this.roomName = "Live";
        WTSDK.Participant.setMediaQuality({ videoHeight: 135, videoWidth: 240, frameRate: 10 })
        break;
      case 2:
        m.waiting.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).pause();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "none";
          }
        });
        m.preview.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).pause();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "none";
          }
        });
        m.live.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).play();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "block";
          }
          this.visibleRooms.push(e.id);
        });
        console.log("I'm in the live room");
        this.roomName = "Live";
        WTSDK.Participant.setMediaQuality({ videoHeight: 1080, videoWidth: 1920, frameRate: 30 });
        break;
      case 3:
        m.live.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).pause();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "none";
          }
        });
        m.waiting.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).play();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "block";
          }
          this.visibleRooms.push(e.id);
        });
        m.preview.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).play();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "block";
          }
          if (this.visibleRooms.indexOf(e.id) != -1) {
            this.visibleRooms.splice(this.visibleRooms.indexOf(e.id), 1)
          }
        });
        console.log("I'm in the waiting and preview rooms");
        this.roomName = "Waiting & Preview";
        WTSDK.Participant.setMediaQuality({ videoHeight: 135, videoWidth: 240, frameRate: 10 })
        break;
      case 4:
        m.preview.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).pause();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "none";
          }
        });
        m.waiting.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).play();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "block";
          }
          this.visibleRooms.push(e.id);
        });
        m.live.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).play();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "block";
          }
          if (this.visibleRooms.indexOf(e.id) != -1) {
            this.visibleRooms.splice(this.visibleRooms.indexOf(e.id), 1)
          }
        });
        console.log("I'm in the waiting and live rooms");
        this.roomName = "Waiting & Live";
        WTSDK.Participant.setMediaQuality({ videoHeight: 135, videoWidth: 240, frameRate: 10 })
        break;
      case 5:
        m.waiting.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).pause();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "none";
          }
        });
        m.preview.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).play();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "block";
          }
          this.visibleRooms.push(e.id);
        });
        m.live.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).play();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "block";
          }
          if (this.visibleRooms.indexOf(e.id) != -1) {
            this.visibleRooms.splice(this.visibleRooms.indexOf(e.id), 1)
          }
        });
        console.log("I'm in the preview and live rooms");
        this.roomName = "Preview & Live";
        WTSDK.Participant.setMediaQuality({ videoHeight: 135, videoWidth: 240, frameRate: 10 })
        break;
      case 6:
        m.waiting.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).play();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "block";
          }
          this.visibleRooms.push(e.id);
        });
        m.preview.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).play();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "block";
          }
          if (this.visibleRooms.indexOf(e.id) != -1) {
            this.visibleRooms.splice(this.visibleRooms.indexOf(e.id), 1)
          }
        });
        m.live.forEach(e => {
          if (this.checkIsElement(e.id)) {
            (<HTMLVideoElement>document.getElementById(e.id)).play();

          }
          if (this.checkIsElement(e.id + "-VC")) {
            document.getElementById(e.id + "-VC").style.display = "block";
          }
          if (this.visibleRooms.indexOf(e.id) != -1) {
            this.visibleRooms.splice(this.visibleRooms.indexOf(e.id), 1)
          }
        });
        console.log("I'm in the waiting, preview and live rooms");
        this.roomName = "Waiting, Preview & Live";
        WTSDK.Participant.setMediaQuality({ videoHeight: 135, videoWidth: 240, frameRate: 10 })
        break;
    }


    $("#roomType").html(this.roomName);
    if (this.roomName == 'Live') {
      $('.user-status').addClass('user-status-active');
    } else {
      $('.user-status').removeClass('user-status-active');
    }

    console.log("this.visibleRooms", this.visibleRooms);
    // if(this.screenShare.isSharedScreen && e.id == this.screenShare.streamId)
    if (this.screenShare.streamId && this.visibleRooms.includes(this.screenShare.streamId)) {
      this.screenShare.isSharedScreen = true;
    } else {
      this.screenShare.isSharedScreen = false;
    }

  }

  checkIsElement(id) {
    if (document.getElementById(id)) {
      return true;
    }
    return false;
  }

  // event listeners
  // guest connect
  async guestConnect() {
    this.videoUserName = this.userInfo.user_display_name;
    console.log("videoUserName: " + this.videoUserName);
    this.host = false;
    this.roomConnect()
  }
  endSession() {
    let params = {
      id: this.session_id,
      endTime: new Date()
    }
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: params
    }
    let url = CONST_AWS_API.END_VIDEO_ROOM_SESSION;
    API.post(environment.AWS_Cognito.apiName, url, data).then(response => {
      // console.log("response", response);
      if (response.data.statusCode === '200') {
        this.router.navigate([`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/expo-details/` + this.expoInfo.id + '/' + this.route.snapshot.params.ticket_key]);
        // this.location.back();
        // this.router.navigate(['/expo/expo-details/' + this.expoInfo.id]);
        // this.disconnect()
        // this.router.navigate(['/expo/expo-details', this.expoInfo.id]);
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }
  disconnect(): any {
    return new Promise((resolve, reject): any => {
      WTSDK.Session.disconnect();
      $('#videoWrapper').html('');
      this.endSession();
      resolve("success");
    });
  }
  // quest connect

  goBack() {
    this.disconnect();
  }

  getLiveEventById() {
    let splits = this.route.snapshot.params.ticket_key.split("-");
    let ids = {
      "stream_id": splits[0],
      "userid": splits[1],
    }
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: ids
    }
    this.ngxLoader.start();
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_LIVE_EVENT_BY_ID, data).then(response => {
      this.ngxLoader.stop();
      this.commanSubscribeService.sendSlugData(response['data']['Data']);
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }
  loadAdsScript() {
    document.querySelectorAll('.videoAds').forEach(vid => (<HTMLVideoElement>vid).pause());
    $('.carousel-inner img').attr('alt', '');
    $('.carousel-inner img').attr('title', '');
    var t;
    var start = $('#myCarousel').find('.active').attr('id');
    t = setTimeout("$('#myCarousel').carousel({interval: 1000});", start - 1000);
    $('#myCarousel').on('slid.bs.carousel', function (ev) {
      clearTimeout(t);
      var duration1 = $(this).find('.active').attr('id');
      console.log(duration1);
      let slides = $(this).find('.carousel-item');
      let pvid = slides[ev.from].querySelectorAll('video')[0];
      if (pvid && (pvid != undefined || pvid != 'undefined')) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll('video')[0];
      if (vid && (vid != undefined || vid != 'undefined')) {
        // vid.muted = true;
        (<HTMLVideoElement>vid).play();
      }
      $('#myCarousel').carousel('pause');
      t = setTimeout("$('#myCarousel').carousel();", duration1 - 1000);
    })
    $('.carousel-control-next').on('click', () => {
      clearTimeout(t);
    });
    $('.carousel-control-prev').on('click', () => {
      clearTimeout(t);
    });
    var r;
    var start = $('#RightCarousel').find('.active').attr('id');
    r = setTimeout("$('#RightCarousel').carousel({interval: 1000});", start - 1000);
    $('#RightCarousel').on('slid.bs.carousel', function (ev) {
      clearTimeout(r);
      var duration2 = $(this).find('.active').attr('id');
      console.log(duration2);
      let slides = $(this).find('.carousel-item');
      let pvid = slides[ev.from].querySelectorAll('video')[0];
      if (pvid && (pvid != undefined || pvid != 'undefined')) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll('video')[0];
      if (vid && (vid != undefined || vid != 'undefined')) {
        // vid.muted = true;
        (<HTMLVideoElement>vid).play();
      }
      $('#RightCarousel').carousel('pause');
      r = setTimeout("$('#RightCarousel').carousel();", duration2 - 1000);
    })
    $('.carousel-control-next').on('click', () => {
      clearTimeout(r);
    });
    $('.carousel-control-prev').on('click', () => {
      clearTimeout(r);
    });
  }

  eventDetails(adInfo) {
    this.streamAds = adInfo['stream_info']['stream_ads'];
    console.log('All ads from dynamo', this.streamAds);
    this.streamAdsData = [];
    if (this.streamAds && this.streamAds.length > 0) {
      this.streamAds.forEach(element => {
        if (element.ad_size && element.ad_size == "728x90" || element.ad_size == "300x600") {
          this.streamAdsData.push(element);
        }
      });
      console.log('Schedule page ads from dynamo', this.streamAdsData);
      if (this.streamAdsData.length > 0) {
        this.getAds();
      }
    }

  }
  selectedAdData: any;
  async getAds() {
    let allDiv = [];
    let count = 0;

    var temp_site_id = null;
    this.preloadAdsdata = [];
    if (this.streamAdsData && this.streamAdsData.length > 0) {
      this.sponsorData = this.streamAdsData;
      var j = 0;
      var i = 1;

      var adTypeIdarr = [];
      var placements = [];
      this.streamAdsData.forEach(el => {
        temp_site_id = Number(el.site_id)
        j += 1;
        adTypeIdarr.push(el.adTypeId);
        placements.push({
          "divName": "div" + i + j,
          "networkId": Number(environment.kevel.NETWORK_ID),
          "siteId": Number(el.site_id),
          "adTypes": [el.adTypeId],
          "campaignId": Number(el.campaignId),
          "flightId": Number(el.flight_id),
          "adId": Number(el.ad_id)
        });
        allDiv.push("div" + i + j);
        count = count + 1;
        if (this.streamAdsData.length == count) {
          let data = {
            "placements": placements,
            "allDiv": allDiv
          };
          if (temp_site_id) {
            this.eventHomeAdsTop = [];
            this.eventHomeAdsRight = [];
            this.commanSubscribeService.getAdsData(data, (err, result) => {
              this.preloadAdsdata = result.Ads_data;
              console.log("Schedule page Ads :::: ", this.preloadAdsdata);
              if (this.preloadAdsdata.length > 0) {
                this.preloadAdsdata.forEach(element => {
                  this.selectedAdData = element.clickUrl;
                  console.log('eventHomeAdsRight selectedAdData :: ', this.selectedAdData);
                  if (element.contents && element.contents[0] && element.contents[0].body && element.width == 728 && element.height == 90) {
                    let adType = element.contents[0];
                    let customData = adType.data['customData'] ? adType.data['customData'] : {};
                    let duration = adType['data']['customData']['maxPlayTime'];
                    this.adVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
                    this.eventHomeAdsTop.push({ 'image': this.adVideo, 'duration': (duration * 1000) });
                    if (element.impressionUrl) {
                      this.commanSubscribeService.countAdsImpressions(element.impressionUrl);
                    }
                  }
                  if (element.contents && element.contents[0] && element.contents[0].body && element.width == 300 && element.height == 600) {
                    let adType = element.contents[0];
                    // let customData = adType.data['customData'] ? adType.data['customData'] : {};
                    let duration = adType['data']['customData']['maxPlayTime'];
                    let rightsadVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
                    this.eventHomeAdsRight.push({ 'image': rightsadVideo, 'duration': (duration * 1000) });
                    if (element.impressionUrl) {
                      this.commanSubscribeService.countAdsImpressions(element.impressionUrl);
                    }
                  }
                });
                console.log('scheduleAdsTop :: ', this.eventHomeAdsTop);
                console.log('scheduleAdsRight :: ', this.eventHomeAdsRight);
                setTimeout(() => {
                  this.loadAdsScript();
                }, 200);
              }
            });
          }
        }
      });
    }
  }
  ngOnDestroy() {
    if (this.expoInterval) {
      clearInterval(this.expoInterval);
    }
    if (this.userInfoSubscription) {
      this.userInfoSubscription.unsubscribe();
    }
  }

}


